export class ModuleRequestInputModel{
    userId:Number;
	departmentId:Number;
	serviceId:Number;
	roleId:Number;

}